module.exports = __webpack_public_path__ + "img/book-poster.ad4c43ca.jpg";